import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

export default buildFacetDesignOverride();
